import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import HttpRoutingService from "../../shared/services/httpRoutingService";
import { API } from "../../shared/apiRoutes";
import { config } from "../../shared/environment";



type OrderReportResponse = {
    orderReport: {
        overallSummary: {
            average_ordered_quantity: number;
            average_orders_income: number;
            returned_quantity: number;
            total_ordered_quantity: number;
        };
        orderSummary: {
            date: string; // format: "DD/MM/YYYY"
            no_of_orders: number;
            total_ordered_quantity: number;
            average_ordered_quantity: number;
            average_orders_income: number;
            returned_quantity: number;
        }[];
        orderSummaryCount: number;
    };
    statusCode: string;
    message: string;
    success: boolean;
};

interface intstate {
    getAllOrderReport: { loading: boolean, value: OrderReportResponse | null, error: string, isReached: boolean, filter: string | null }

}

const initialState: intstate =
{
    getAllOrderReport: { loading: false, value: null, error: '', isReached: false, filter: null }
}



export const getAllOrderReport = createAsyncThunk('orderReport/getAll', ({ data }: { data: { limit: number, offset: number, filterData: string, locationId: number } }) => {
    let Url = HttpRoutingService.replaceUrl(API.orderReport, { storeId: config.storeId })
    return HttpRoutingService.getMethod<OrderReportResponse>(Url, data)
})



const orderReportSlice = createSlice({
    initialState,
    name: 'orderReport',
    reducers: {},
    extraReducers(builder) {
        builder
            .addCase(getAllOrderReport.pending, (state, action) => {
                state.getAllOrderReport.loading = true
            })
            .addCase(getAllOrderReport.fulfilled, (state, action) => {
                state.getAllOrderReport.loading = false
                let prev = state.getAllOrderReport.value;
                let current = action.payload;
                let combine: OrderReportResponse | null = null
                let offset = action.meta.arg.data.offset
                if (offset > 0) {
                    combine = {
                        message: current?.message ?? prev?.message ?? "",
                        statusCode: current?.statusCode ?? prev?.statusCode ?? "",
                        success: current?.success ?? prev?.success ?? false,
                        orderReport: {
                            overallSummary: {
                                ...prev?.orderReport?.overallSummary,
                                ...current?.orderReport?.overallSummary,
                            },
                            orderSummary: [
                                ...(prev?.orderReport?.orderSummary || []),
                                ...(current?.orderReport?.orderSummary || []),
                            ],
                            orderSummaryCount:
                                (prev?.orderReport?.orderSummary?.length || 0) +
                                (current?.orderReport?.orderSummary?.length || 0),
                        },
                    };
                }
                if (current.orderReport.orderSummary.length < action.meta.arg.data.limit) {
                    state.getAllOrderReport.isReached = true
                }
                else {
                    state.getAllOrderReport.isReached = false
                }
                state.getAllOrderReport.value = offset > 0 ? combine : action.payload
                state.getAllOrderReport.filter = action.meta.arg.data.filterData
            })
            .addCase(getAllOrderReport.rejected, (state, action) => {
                state.getAllOrderReport.loading = false
                state.getAllOrderReport.error = action.error.message as string
            })

    },
})


export default orderReportSlice?.reducer